export const SET_POINT_DE_VENTE_ADRESSE = 'SET_POINT_DE_VENTE_ADRESSE';
export const SET_RECOMMANDATION = 'SET_RECOMMANDATION';
export const SET_MARKER_PANNEAU = 'SET_MARKER_PANNEAU';
export const SET_PANNEAUX_SOUS_CONTRAT = 'SET_PANNEAUX_SOUS_CONTRAT';
export const SET_POINT_DE_VENTE = 'SET_POINT_DE_VENTE';
export const SET_ASSISTANT_ID = 'SET_ASSISTANT_ID';
export const DELETE_RESTOR_PANNEAU = 'DELETE_RESTOR_PANNEAU';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SET_PRODUITS_LOCATION = 'SET_PRODUITS_LOCATION';
export const SET_LIGNE_COMMANDE_PANNEAU_TO_DEVIS = 'SET_LIGNE_COMMANDE_PANNEAU_TO_DEVIS';
export const SET_LIGNES_COMMANDE = 'SET_LIGNES_COMMANDE';
export const CALCULER_THEME = 'CALCULER_THEME';
export const SET_PANNEAU_EXISTANT = 'SET_PANNEAU_EXISTANT';
